import { render, staticRenderFns } from "./BuyerAccountApplicationRecord.vue?vue&type=template&id=71e6df7e&scoped=true"
import script from "./BuyerAccountApplicationRecord.vue?vue&type=script&lang=js"
export * from "./BuyerAccountApplicationRecord.vue?vue&type=script&lang=js"
import style0 from "./BuyerAccountApplicationRecord.vue?vue&type=style&index=0&id=71e6df7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e6df7e",
  null
  
)

export default component.exports